import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import StoreStatus from 'src/dispensary/core-menu/components/core-menu-header/store-status';
import MenuTypeSelector from 'components/menu-type-selector';

function StatusMenuSelect({ dispensary, ...otherProps }) {
  return (
    <Container {...otherProps}>
      <StoreStatus dispensary={dispensary} inline />
      <MenuTypeSelector dispensary={dispensary} />
    </Container>
  );
}

export default StatusMenuSelect;

const Container = styled.div`
  background: var(--dcm-menu-select-bg);
  height: var(--dcm-menu-select-height);
  padding-left: var(--dcm-menu-select-padding-x);
  padding-right: var(--dcm-menu-select-padding-x);
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${space}
`;
